module.exports = __webpack_public_path__ + "static/img_9701-f52b6c878a6886d9f12c8e3c578c434a.webp";